import Vue from 'vue';
import store from 'store/mainStore';
import 'es6-promise/auto';
import utils from 'js/services/utils';
import 'quasar/dist/quasar.umd.min';

Vue.use(utils);

(function(wv, undefined){
	wv.store = store;
	wv.signin = new Vue({
		el: "#signinWrapper",
		store,
		components: {
			'signin': () => import(/* webpackPrefetch: true */ 'components/signin/signinMain'),
		},
		methods: {
			successfulLogin: function(response){
				this.$store.commit('common/setAttribute', {loggedIn: true});
				this.$store.commit('common/setAttribute', {userFullName: response.data.userFullName});
				// wv.header.nonce++;
				this.$emit('update:login');
				const redirectTo = Cookies.get("currentLocation");
				Cookies.remove("currentLocation");
				window.location = redirectTo ? redirectTo : "/";
			}
		}
	});
}( window.wv = window.wv || {} ));